const AI_DESCRIPTION_STYLES = [
  196600, 704300, 889500, 1012000, 1038100, 1038800, 1119400, 1186500, 1249300,
  262200, 300300, 301800, 656800, 820300, 853600, 1062500, 1078300, 1251000,
  1806000, 174000, 1092300, 1182400, 1250300, 1509500, 1517000, 1595900, 255200,
  705100, 1060900, 1186600, 1235500, 1250200, 1491800, 1509600, 1510300,
  1513100, 1599200, 1622700, 1801400, 301600, 653600, 154200, 1515700, 1516500,
  180900, 1054100, 1154600, 1169900, 1186300, 1492000, 1535700, 1596000,
  1598800, 1801300, 255100, 703700, 802200, 1119500, 1121300, 1492100, 1516700,
  1596100, 1599000, 1599100, 1608000, 1729700, 1781600, 180800, 292300, 301900,
  394600, 657700, 703900, 802300, 894600, 1051700, 1178400, 1497800, 1510200,
  1513000, 1515600, 1536100, 1616300, 1622800, 1729600, 1755200, 1781700,
  1805500
];

export default AI_DESCRIPTION_STYLES;
